import { Title, Box, Stack } from '@mantine/core';
import ListCard from './ListCard';
import ReportContext from 'context/ReportContext';
import { useContext } from 'react';

const Summary = () => {
  const {
    data: { callDetails, isLoadingCallDetails },
  } = useContext(ReportContext);
  const { summary } = callDetails;
  const defaultActionItems = ['No further action'];
  const defaultDiscussionPoints = ['No discussion'];

  // Helper function to handle summary fields - backend now returns arrays directly
  const getSummaryField = (field: string[] | string | undefined, defaultValue: string[]): string[] => {
    // If field is already an array (new backend format)
    if (Array.isArray(field)) {
      return field.length > 0 ? field : defaultValue;
    }
    
    // If field is an empty string or undefined (old/legacy format), use default
    if (!field || field === '') {
      return defaultValue;
    }
    
    // If field is some other unexpected format, log error and use default
    console.error('Unexpected summary field format. Expected array, got:', typeof field, field);
    return defaultValue;
  };

  const actionItems = getSummaryField(summary?.action, defaultActionItems);
  const discussionPoints = getSummaryField(summary?.discussion, defaultDiscussionPoints);

  return (
    <Box w="100%">
      <Title size="md" mb="lg" fw={600}>
        Summary
      </Title>

      <Stack gap="md">
        <ListCard
          title="Key discussion points:"
          list={discussionPoints}
          isLoading={isLoadingCallDetails}
        />
        <ListCard
          title="Action items:"
          list={actionItems}
          isLoading={isLoadingCallDetails}
        />
      </Stack>
    </Box>
  );
};

export default Summary;
